import { Eye } from "lucide-react";
import { Button } from "../ui/button";
import { PdfButton } from "../PdfButton";
import { ROLE_LABEL } from "../../lib/api";
import { POLDA_CATS, POLDA_CAT_SHORT } from "../../lib/icons";

export const STATUS = {
  "BELUM MENGISI": { cls: "bg-rose-600 text-white", hint: "Belum ada data almatsus / DF" },
  "TIDAK DIPERBARUI": { cls: "bg-amber-500 text-white", hint: "Aktivitas terakhir melewati batas" },
  "BELUM DIPERBARUI": { cls: "bg-slate-500 text-white", hint: "Hanya data impor awal, belum ada pembaruan" },
  AKTIF: { cls: "bg-emerald-600 text-white", hint: "Diperbarui dalam batas waktu" },
};

const ago = (iso) => Math.floor((Date.now() - new Date(iso).getTime()) / 86400000);
const fmt = (iso) => new Date(iso).toLocaleDateString("id-ID", { day: "2-digit", month: "short", year: "numeric" });

const Activity = ({ r }) =>
  r.last_activity ? (
    <div className="leading-tight">
      <div className="font-mono text-xs">{fmt(r.last_activity)} <span className="text-muted-foreground">({ago(r.last_activity)} hari lalu)</span></div>
      <div className="text-xs text-muted-foreground">{r.last_by} &middot; {ROLE_LABEL[r.last_by_role]}</div>
    </div>
  ) : <span className="text-xs text-muted-foreground">Belum ada aktivitas</span>;

const Account = ({ a }) =>
  a.total ? (
    <div className="leading-tight text-xs">
      <div>{a.active}/{a.total} akun aktif</div>
      <div className="text-muted-foreground">{a.last_login ? `Login ${fmt(a.last_login)}` : "Belum pernah login"}</div>
    </div>
  ) : <span className="text-xs text-rose-600 font-medium">Belum ada akun</span>;

export const StatusTable = ({ rows, onOpen }) => (
  <div className="border bg-card overflow-x-auto">
    <table className="w-full text-sm" data-testid="polda-status-table">
      <thead>
        <tr className="text-left border-b bg-muted/60">
          <th className="px-5 py-2.5 eyebrow">Polda</th>
          <th className="px-3 py-2.5 eyebrow">Status</th>
          {POLDA_CATS.map((k) => <th key={k} className="px-3 py-2.5 eyebrow text-right">{POLDA_CAT_SHORT[k]}</th>)}
          <th className="px-3 py-2.5 eyebrow">Aktivitas Terakhir</th>
          <th className="px-3 py-2.5 eyebrow">Akun Polda</th>
          <th className="px-5 py-2.5 eyebrow text-right">Aksi</th>
        </tr>
      </thead>
      <tbody>
        {rows.map((r) => (
          <tr key={r.polda} className="border-b last:border-0 hover:bg-muted/40 transition-colors" data-testid={`status-row-${r.polda}`}>
            <td className="px-5 py-3 font-medium whitespace-nowrap">{r.polda}</td>
            <td className="px-3 py-3">
              <span title={STATUS[r.status].hint} className={`px-2 py-0.5 text-[11px] font-semibold uppercase rounded-sm whitespace-nowrap ${STATUS[r.status].cls}`}>{r.status}</span>
            </td>
            {POLDA_CATS.map((k) => <td key={k} className="px-3 py-3 text-right font-mono">{r[k]}</td>)}
            <td className="px-3 py-3"><Activity r={r} /></td>
            <td className="px-3 py-3"><Account a={r.accounts} /></td>
            <td className="px-5 py-2 text-right whitespace-nowrap space-x-1">
              <Button size="sm" variant="ghost" onClick={() => onOpen(r.polda)} data-testid={`status-open-${r.polda}`}><Eye className="h-4 w-4" /> Data</Button>
              <PdfButton size="sm" variant="ghost" label="PDF" params={{ scope: "polda", polda: r.polda }} testId={`status-pdf-${r.polda}`} />
            </td>
          </tr>
        ))}
        {!rows.length && (
          <tr><td colSpan={8} className="px-5 py-10 text-center text-sm text-muted-foreground" data-testid="status-empty">Tidak ada Polda dengan status ini.</td></tr>
        )}
      </tbody>
    </table>
  </div>
);
